import { Alignment, Displaying } from "@bonusx-global/bx-design-system";
import styled from "@emotion/styled";
import Box from "@mui/material/Box";
import type { PropsWithChildren } from "react";

const BoxCenteredElement = styled(Box)({
  display: Displaying.flex,
  alignItems: Alignment.center,
  justifyContent: Alignment.center,
});

interface BoxCenteredProps {
  readonly className?: string;
  readonly id?: string;
}

export function BoxCentered({ children, className, id }: PropsWithChildren<BoxCenteredProps>) {
  return <BoxCenteredElement {...{ className, id }}>{children}</BoxCenteredElement>;
}
